import { RocketLaunchSharp } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

type PropsType = {
  title?: string;
  fullScreen?: boolean;
  onClick?: () => void;
};

const ComingSoon = (props: PropsType) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={`w-full ${props.fullScreen ? "h-screen" : "h-full"} flex items-center justify-center overflow-hidden`}
      >
        <div className="w-full relative flex items-center justify-center overflow-hidden py-12">
          <div
            aria-hidden="true"
            className="pointer-events-none select-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[200px] md:text-[400px] leading-none text-primary font-bold opacity-5 whitespace-nowrap"
          >
            SOON
          </div>
          <div className="w-full relative z-10 flex flex-col gap-8 items-center justify-center">
            <RocketLaunchSharp className="w-[128px] h-[129px] text-primary" />
            <div className="flex flex-col gap-2 justify-center">
              <div className="text-[32px] text-primary font-bold text-center">
                {props.title ?? "Coming Soon"}
              </div>
              <div className="text-gray-400 text-center">
                This feature is not available yet.
                <br />
                It is under development and will be released soon.
              </div>
            </div>
            <Button
              variant="contained"
              onClick={() => (props.onClick ? props.onClick() : navigate("/"))}
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
